import React from 'react'
import { Link } from 'react-router-dom'
import mac from "./img/mycirclewatch.png"
import web from "./img/mycirclewatch.png"
import Image from "../../../../Components/Image"

function Broadcast() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">Broadcast!</div>
                <div className="work_type">Apple Watch Application</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                        Create and share broadcasts quickly from your smart watch. Broadcast! allows you to keep your friends on Oudi and MyCircles up to date with what is happening.
                    </p>
                    <p>
                    </p>

                </div>
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">

                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> Swift, WatchUI.</div>
                    </p>
                    <p>
                        <div className="dev_title">Back End</div>
                        <div className="dev_info">NodeJs, Express, Firebase, Cloud functions</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default Broadcast